export default "__VITE_ASSET__NCevkNg6__"